import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';
import './AccessDenied.scss';

const AccessDenied = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('userInfo') || '{}');

  return (
    <div className="access-denied">
      <Card className="access-denied-card">
        <Card.Body>
          <div className="icon-container">
            <i className="bi bi-shield-lock-fill"></i>
          </div>
          <h1>Access Denied</h1>
          <p className="message">
            You don't have permission to access this page.
          </p>
          {user.role && (
            <p className="role-info">
              Your current role: <span className="role-badge">{user.role}</span>
            </p>
          )}
          <p className="help-text">
            If you believe you should have access to this page, please contact your administrator.
          </p>
          <div className="button-group">
            <Button variant="primary" onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
            <Button variant="outline-secondary" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AccessDenied;
